import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printing-table',
  templateUrl: './printing-table.component.html',
  styleUrls: ['./printing-table.component.scss']
})
export class PrintingTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
